import type { AppDispatch } from './Store';
import {
  ClearCart,
  clearCartOrderData,
  setUpdatingCartitems,
} from './cartSlice';
import { clearOrderDetails } from './orderDetailsSlice';

/**
 * Drops any "editing existing order" state so the next add starts a new
 * order rather than continuing the pending/partial one. Callers may opt in
 * to also wiping the cart items themselves via `alsoClearCart`.
 */
export const exitEditingCurrentOrder =
  (opts?: { alsoClearCart?: boolean }) => (dispatch: AppDispatch) => {
    if (opts?.alsoClearCart) dispatch(ClearCart());
    dispatch(clearCartOrderData());
    dispatch(setUpdatingCartitems(false));
    dispatch(clearOrderDetails());
  };
